import PCard from 'pages/finance/transactions/main/PCard';
import React, { useMemo } from 'react';
import Select from 'react-select';

const PICSelect = ({ admissions, handledBy, onChange }) => {
  const options = useMemo(() => {
    return admissions.map((admission) => {
      return {
        value: admission.username,
        label: `${admission.firstName} ${admission.lastName} - ${admission.email} - ${admission.username}`,
      };
    });
  }, [admissions]);

  return (
    <PCard className="mb-2 p-3">
      <div className="font-weight-bold mb-2">PIC</div>

      <Select
        id="handledBy"
        name="handledBy"
        value={handledBy}
        options={[{ value: '-', label: 'Other' }, ...options]}
        onChange={onChange}
      />
    </PCard>
  );
};

export default PICSelect;
